import React from 'react';
import en from './locales/en.json';
import ja from './locales/ja.json';
import zhHant from './locales/zh-Hant.json';
const zh = (process.env.zhText || en) as typeof en;
const Context = React.createContext(
  {} as typeof zh & {
    feedback_text: any;
  }
);

export { Context, zh, en, ja, zhHant };
